import { render, staticRenderFns } from "./w-my-profile.vue?vue&type=template&id=783715b3"
import script from "./w-my-profile.vue?vue&type=script&lang=js"
export * from "./w-my-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports